import React, { Fragment, useEffect, useState, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useRouter, withRouter } from "next/router";
import OtpVerification from "../../components/common/OtpVerification";
import { Form, Button } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_KEY } from "../../config";
import { useGoogleLogin } from "@react-oauth/google";
import {
  getGoogleUserInfo,
  login,
  loginWithFacebook,
  submitOtp,
} from "../../store/actions/auth";

import { get_cookie, set_cookie } from "../../utils";
import MainModal from "../../components/modals/mainModal";
import TermsModal from "../../components/modals/termsModal";
import PrivacyModal from "../../components/modals/privacyModal";
import TelInputFunctional from "components/phoneInput";
import { setShowOtpBlock } from "store/actions";

//Internal
import googlelogo from "../../public/assets/images/google.svg";

const Login = ({ currentLocationId, handleClose }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.user?.token);
  const showOtpBlock = useSelector((state) => state.ui.showOtpBlock);
  const [phoneNumber, setPhoneNumber] = useState({});
  const [isoCode, setisoCode] = useState("");
  const [value, setValue] = useState("");
  const [otpError, setotpError] = useState("");
  const [numValidation, setNumValidation] = useState({
    valid: false,
    error: "",
  });
  const [showTermsOfUse, setShowTermsOfUse] = useState(false);
  const termsOfUseClose = () => setShowTermsOfUse(false);
  const termsOfUseShow = () => setShowTermsOfUse(true);

  // Privacy Policy Modal
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const privacyPolicyShow = () => setShowPrivacyPolicy(true);

  // Recaptcha
  const recaptchaRef = useRef();
  const [recaptchaToken, setRecaptchaToken] = useState("");

  const query = router.query.verify;

  // Show/Hide Event
  const showLoginBlock = () => dispatch(setShowOtpBlock(false));
  const hideLoginBlock = () => dispatch(setShowOtpBlock(true));

  useEffect(() => {
    if (get_cookie("phoneNoOrderTime")) {
      let phoneNum = get_cookie("phoneNoOrderTime").trim();
      let phonePrefix = phoneNum.split(" ")[0];
      let phoneSufix = phoneNum.split(" ").slice(1, phoneNum.length).join("");
      setPhoneNumber({
        country_code: `+${phonePrefix}`,
        contact_number: phoneSufix,
      });
      setValue(phoneSufix);
      clearPhoneCountryShortNameCookie();
    }

    if (router?.query?.slug?.length != 6) {
      if (token) {
        handleClose();
        // router.push("/personal-details");
      }
    }
  }, [token]);

  // reset phonenumber if showOtpBlock false
  useEffect(() => {
    if (!showOtpBlock) {
      setPhoneNumber({});
      setNumValidation({
        valid: false,
        error: "",
      });
    }
  }, [showOtpBlock]);

  const clearPhoneCountryShortNameCookie = () => {
    set_cookie("phoneNoOrderTime", "");
    set_cookie("countryShortnameOrderTime", "");
  };

  /*******************
  @Purpose : Used for handle change in phone number
  @Parameter : {value, country}
  @Author : INIC
  *******************/
  const handleInputChange = (val, country, isValid) => {
    setNumValidation({ valid: isValid, error: "" });
    setisoCode(country.iso2);
    setPhoneNumber({
      country_code: `+${country.dialCode}`,
      contact_number: val,
    });
  };
  /*******************
  @Purpose : Used for handle signup/sign in submit
  @Parameter : {form data}
  @Author : INIC
  *******************/
  const handleFormSubmit = async (data) => {
    if (data) {
      if (!numValidation.valid) {
        throughVaidationError(numValidation.valid);
      } else {
        // Execute reCAPTCHA before submitting
        try {
          const token = await recaptchaRef.current.executeAsync();
          if (!token) {
            setNumValidation({
              valid: false,
              error: "Captcha verification failed. Please try again.",
            });
            return;
          }
          setRecaptchaToken(token);

          let loginData = {
            country_code: data.country_code,
            contact_number: data.contact_number,
            country_shortname: isoCode.toUpperCase(),
            recaptcha_token: token, // Include captcha token
          };
          dispatch(login(loginData))
            .then(() => {
              set_cookie("isoCode", isoCode);
              // Reset reCAPTCHA after successful login
              recaptchaRef.current.reset();
              hideLoginBlock();
              setValue("");
            })
            .catch((err) => {
              setNumValidation({ valid: false, error: err.message });
              // Reset reCAPTCHA on error
              recaptchaRef.current.reset();
            });
        } catch (error) {
          setNumValidation({
            valid: false,
            error: "Captcha verification failed. Please try again.",
          });
        }
      }
    }
  };

  /*******************
  @Purpose : Used for handle otp submit
  @Parameter : {form data}
  @Author : INIC
  *******************/
  const handleOtpSUbmit = async (otp) => {
    let otpData = {
      country_code: phoneNumber.country_code,
      contact_number: phoneNumber.contact_number,
      country_shortname: isoCode.toUpperCase(),
      otp: otp,
    };

    dispatch(submitOtp(otpData))
      .then((res) => {
        handleClose();
      })
      .catch((err) => {
        setotpError("");
        setTimeout(() => {
          setotpError(err.message);
        });
      });
  };

  /*******************
  @Purpose : Used for Social login handler
  @Parameter : {user,err}
  @Author : INIC
  *******************/
  const handleSocialLogin = (type, user, flag) => {
    switch (type) {
      case "facebook":
        dispatch(loginWithFacebook(user, currentLocationId));
        if (flag) {
          handleClose();
        }
        break;
      case "google":
        // dispatch(loginWithGoogle(user, currentLocationId));
        if (flag) {
          handleClose();
        }
        break;
      default:
        return false;
    }
  };

  /*******************
  @Purpose : Used to through Error if number is not valid
  @Parameter : {valid}
  @Author : INIC
  *******************/
  const throughVaidationError = (valid) => {
    if (!valid) {
      setNumValidation({
        valid: valid,
        error: "Please enter a valid phone number",
      });
      // setTimeout(() => {
      // setPhoneNumber((data) => ({ ...data, contact_number: "" }));
      // setNumValidation({ ...valid, error: "" });
      // }, 3000);
    }
  };

  /*******************
  @Purpose : used to submit code on enter
  @Parameter : {}
  @Author : INIC
  *******************/
  const submitOnEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleFormSubmit(phoneNumber);
    }
  };

  const googleLoginHandler = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (tokenResponse) {
        dispatch(
          getGoogleUserInfo(tokenResponse?.access_token, currentLocationId)
        );
        handleClose();
      }
    },
    onError: (errorResponse) => console.log(errorResponse),
  });

  /*******************
  @Purpose : redirect to new page
  @Parameter : {}
  @Author : INIC
  *******************/
  const redirectToNewPage = (path) => {
    window.open("/" + path, "_blank");
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  if (token) {
    return <Fragment></Fragment>;
  }

  return (
    <>
      {/* {loaders && loaders.content_loader && <ContentLoader />} */}

      <main className="login-main">
        {showOtpBlock ? (
          <>
            <OtpVerification
              error={otpError}
              showLoginBlock={showLoginBlock}
              phoneNumber={phoneNumber}
              handleOtpSUbmit={handleOtpSUbmit}
              resendOtp={handleFormSubmit}
              showOtpBlock={showOtpBlock}
            />
          </>
        ) : (
          <section className="login-block">
            <div className="login-block-inner p-0">
              <div className="onboarding-card p-0 border-0">
                <h4 className="card-title text-center">Welcome to Falcon</h4>

                {/* Form */}
                <Form className="onboarding-form" onKeyPress={submitOnEnter}>
                  <div
                    className={`d-flex align-items-start mb-0 input-field ${!numValidation.valid && numValidation.error && "error"
                      }`}
                  >
                    <div className="floating-form">
                      <Form.Group
                        controlId="phoneNumber"
                        className="floating-form-group inner-phone-number"
                      >
                        <TelInputFunctional
                          fieldName="contact_number"
                          className="floating-input"
                          value={value}
                          setValue={setValue}
                          handleInputChange={handleInputChange}
                          label={"phone number"}
                          setNumValidation={setNumValidation}
                          // country={
                          //   get_cookie("isoCode")
                          //     ? get_cookie("isoCode").toLowerCase()
                          //     : "us"
                          // }
                          setcountryIso={setisoCode}
                        />
                      </Form.Group>

                      {/* Error Message */}
                      {numValidation?.error && (
                        <span className="error-msg">
                          {!numValidation.valid && numValidation.error}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Social Login Buttons */}
                  <p className="tnc-text">
                    By continuing, you agree to Falcon's{" "}
                    <span
                      className="modal-link"
                      onClick={() => redirectToNewPage("terms-and-conditions")}
                    >
                      Terms of Use
                    </span>{" "}
                    and{" "}
                    <span
                      className="modal-link"
                      onClick={() => redirectToNewPage("privacy-policy")}
                    >
                      Privacy Policy
                    </span>
                    .
                  </p>

                  <Button
                    variant="primary"
                    type="button"
                    className="w-100 hover-white"
                    onClick={() => handleFormSubmit(phoneNumber)}
                  >
                    Continue
                  </Button>

                  {/* Hidden reCAPTCHA */}
                  {RECAPTCHA_KEY && (
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={RECAPTCHA_KEY}
                      size="invisible"
                      badge="bottomright"
                    />
                  )}
                </Form>

                <div className="orline">
                  <span>OR</span>
                </div>

                <div className="social-login">
                  <a
                    className="btn btn-social"
                    onClick={() => googleLoginHandler()}
                  >
                    <img src={googlelogo} alt="Sign In with Google" />
                    <span>Continue with Google</span>
                  </a>
                  {/* 
                  <FacebookLogin
                    appId={FB_ID}
                    fields="name,email,picture"
                    callback={(user) =>
                      handleSocialLogin("facebook", user, true)
                    }
                    onFailure={(error) =>
                      handleSocialLogin("facebook", error, false)
                    }
                    render={(renderProps) => (
                      <a
                        className="btn btn-social"
                        onClick={renderProps.onClick}
                      >
                        <img src={fblogo} alt="Sign In with Facebook" />
                        <span>Continue with Facebook</span>
                      </a>
                    )}
                  /> */}
                </div>
              </div>
            </div>
          </section>
        )}
      </main>

      {/* Terms of Use - Modal */}
      <MainModal
        showHandler={showTermsOfUse}
        hideHandler={termsOfUseClose}
        body={<TermsModal />}
        modalTitle="Terms and Conditions"
      />

      {/* Privacy Policy - Modal */}
      <MainModal
        showHandler={showPrivacyPolicy}
        hideHandler={setShowPrivacyPolicy}
        body={<PrivacyModal />}
        modalTitle="Privacy Policy"
      />
    </>
  );
};

/********************
@purpose : Connect With Redux
@Parameter : {common}
@Author : INIC
******************/
const mapStateToProps = ({ common }) => ({
  currentLocationId: common?.currentLocationId,
});
export default withRouter(connect(mapStateToProps)(Login));
